import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../DomainTypes';
import Note from './Note';
import INoteListHost from './INoteListHost';
import { NotificationDuration } from '../../../App/Models/NotificationDuration';
import { NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class NoteVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private genericApiClient = AppService.get(Types.Domain.ApiClients.CatalogueGeneric)) {

        super(taskRunner);
    }

    public newNote: Note | null = null;

    public async saveNotes(parentModel: INoteListHost) {
        this.taskRunner.run(async () => {
            parentModel.setIdOnNote(this.newNote!);
            var response = await this.genericApiClient.saveNote(this.newNote!.toJSObject());
            this.newNote!.update(response.data);
            parentModel.notes.push(this.newNote!);
            this.notifications.addSuccess("Saved Successfully", "Notes saved successfully.", NotificationDuration.Standard);
            this.newNote = null;
        });
    }

    public createNewNote(parentModel: INoteListHost) {
        this.newNote = parentModel.notes.createChild();
    }

    public pushNote(parentModel: INoteListHost) {
        parentModel.notes.push(this.newNote!);
        this.newNote = null;
    }

    public completeNote(note: Note) {
        this.taskRunner.run(async () => {
            const result = await this.genericApiClient.completeNote(note.noteId);
            note.update(result.data);
            this.notifications.addSuccess("Note Completed", "Note completed successfully.", NotificationDuration.Standard);
        });
    }
}